/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck - Material Tailwind component prop warnings
import React, { useState } from 'react';
import { PiFileCsv } from 'react-icons/pi';
import AppButton from '@/components/atoms/AppButton';

import {
  ERequestMethods,
  fetchFileDownload,
  postFetchFileDownload,
} from '@/constant/downloadReport/downloadReport';
import {
  EReportFormat,
  EReportLabel,
} from '@/constant/downloadReport/downloadReport.const';
import { ExportDataModal } from './index';
import { ExportModalDocumentFormatTypes } from './export.types';

type TDownloadReportProps = {
  type: EReportFormat;
  url: string;
  orderBy?: string;
  order?: string;
  label: EReportLabel;
  disableButton?: boolean;
  limit?: number;
  dateFilterBy?: string;
  startDate?: string;
  endDate?: string;
  timeZone: string;
  marketId?: string;
  operatorId?: string;
  deviceId?: string;
  locationId?: string;
  inactive?: boolean;
  subAppId?: string;
  fileName?: string;
  modalTitle?: string;
  requestMethod?: string;
  sourceOrderId?: string;
  includeInactive?: boolean;
  sourceProductId?: string;
  productCode?: string;
  name?: string;
  deviceIdentifier?: string;
  deviceType?: string;
  supportingReportFormats?: { id: string; name: string }[];
  selectiveFieldExport: boolean;
  allowedFieldsForExport: string[];
  barcode?: string;
  testId?: string;
};

const DownloadReport = ({
  type,
  url,
  orderBy,
  order,
  label,
  disableButton,
  limit,
  dateFilterBy,
  startDate,
  endDate,
  timeZone,
  inactive,
  subAppId,
  fileName,
  modalTitle,
  sourceOrderId,
  sourceProductId,
  productCode,
  name,
  supportingReportFormats,
  includeInactive,
  deviceIdentifier,
  deviceType,
  requestMethod = ERequestMethods.GET,
  selectiveFieldExport,
  allowedFieldsForExport,
  testId,
  barcode,
  ...rest
}: TDownloadReportProps) => {
  const [open, setOpen] = useState(false);

  const handleExport = async (exportPayload: {
    documentFormat?: EReportFormat;
    page?: number;
    limit?: number;
    fields?: string[];
  }) => {
    try {
      requestMethod !== ERequestMethods.GET
        ? await postFetchFileDownload({
          type,
          url,
          orderBy,
          order,
          limit,
          dateFilterBy,
          startDate,
          endDate,
          timeZone,
          inactive,
          subAppId,
          fileName,
          exportPayload,
          sourceOrderId,
          sourceProductId,
          productCode,
          name,
          includeInactive,
          selectiveFieldExport,
          deviceIdentifier,
          deviceType,
          barcode,
          ...rest,
        })
        : await fetchFileDownload({
          type,
          url,
          orderBy,
          order,
          limit,
          dateFilterBy,
          startDate,
          endDate,
          timeZone,
          inactive,
          exportPayload,
          subAppId,
          fileName,
          includeInactive,
          deviceIdentifier,
          deviceType,
          selectiveFieldExport,
          ...rest,
        });
    } catch (err) {
      // Download failed — error is handled inside executeBlobDownload
    } finally {
      setOpen(false);
    }
  };

  return (
    <>
      <AppButton
        variant="secondary"
        size="lg"
        icon={<PiFileCsv />}
        onClick={() => setOpen(true)}
        disabled={!!disableButton}
        dataTestId={testId ?? ''}
      >
        {label}
      </AppButton>
      <ExportDataModal
        open={open}
        onClose={() => setOpen(false)}
        totalRecords={limit}
        allowedFormats={
          supportingReportFormats?.length
            ? supportingReportFormats
            : ExportModalDocumentFormatTypes
        }
        onGenerate={handleExport}
        modalTitle={modalTitle}
        selectiveFieldExport={selectiveFieldExport}
        allowedFieldsForExport={allowedFieldsForExport}
        dataTestId={testId}
      />
    </>
  );
};

export default DownloadReport;
